import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";

import storage from "redux-persist/lib/storage";
import userSlice from "./user";
import campaignSlice from "./campaign";
import recoverSlice from "./recover";
import employeeSlice from "./employee";
import roles_skills from "./roles_skills";
import sweepstakesSlice from "./sweepstakes";
import raffleSlice from "./raffle";
import { skillsApi } from "./skillsApi";
import { pendingInvitesApi } from "./pendingInvitesApi";

const reducer = combineReducers({
  user: userSlice,
  campaign: campaignSlice,
  employee: employeeSlice,
  recover: recoverSlice,
  roles_skills: roles_skills,
  sweepstakes: sweepstakesSlice,
  raffle: raffleSlice,
  [skillsApi.reducerPath]: skillsApi.reducer,
  [pendingInvitesApi.reducerPath]: pendingInvitesApi.reducer,
});
const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: ["user"],
};
console.log(persistConfig)

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(skillsApi.middleware, pendingInvitesApi.middleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
